import { DashboardFilterService } from './../../../services/dashboard-filter.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'app-range-date-picker',
    templateUrl: './range-date-picker.component.html',
    styleUrls: ['./range-date-picker.component.scss'],
    standalone: false
})
export class RangeDatePickerComponent {
	@Output('changeDate') emitChangeDate = new EventEmitter();
	rangePickerOptions: any = {
		locale: {
			format: 'DD/MM/YYYY',
			separator: ' - ',
			applyLabel: 'Aplicar',
			cancelLabel: 'Cancelar',
			fromLabel: 'De',
			toLabel: 'Até',
			customRangeLabel: 'Personalizado',
			daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
		},
		alwaysShowCalendars: true,
		startDate: undefined,
		endDate: undefined,
		dateLimit: { days: 366 },
		showCustomRangeLabel: false,
		autoUpdateInput: false,
    ranges: {
      'Hoje': [ moment(), moment() ],
      'Ontem': [ moment().subtract(1, 'days'), moment().subtract(1, 'days') ],
      'Últimos 7 dias': [ moment().subtract(7, 'days'), moment() ],
      'Últimos 30 dias': [ moment().subtract(30, 'days'), moment() ],
      'Mês atual': [ moment().date(1), moment() ],
      'Mês passado': [ moment().subtract(1, 'month').date(1), moment().date(1).subtract(1, 'days') ],
      'Últimos 3 meses': [ moment().subtract(3, 'month'), moment() ],
      'Últimos 6 meses': [ moment().subtract(6, 'month'), moment() ],
      'Limpar': [ moment(), moment() ]
  },
	};
	@Input() filter: DashboardFilterService;

	constructor() {
		if (this.filter && this.filter.startDate) {
			this.rangePickerOptions.startDate = this.filter.startDate;
			this.rangePickerOptions.endDate = this.filter.endDate;
		} else {
			this.rangePickerOptions.startDate = undefined;
			this.rangePickerOptions.endDate = undefined;
		}
	}

	clearFilter(): void {
		this.filter.clear();
	}

	selectedDate(value: any): void {
		 this.setRange(value.startDate, value.endDate);
		this.emitChangeDate.emit(this.filter);
	}

	setRange(start: moment.Moment, end: moment.Moment): void {
		if (!start || !start.isValid() || !end || !end.isValid()) {
			start = undefined;
			end = undefined;
		}

		this.filter.startDate = start;
		this.filter.endDate = end;
		this.rangePickerOptions.startDate = start;
		this.rangePickerOptions.endDate = end;
	}

	get currentDateRange(): string {
		if (this.filter && this.filter.startDate && this.filter.endDate) {
			return this.filter.startDate.format('DD/MM/YYYY') + ' - ' + this.filter.endDate.format('DD/MM/YYYY');
		} else {
			return '';
		}
	}
}
